import React from 'react';
import { Link } from 'react-router-dom';
import { Flame, Instagram } from 'lucide-react';
import { services } from '../data/services';
export function Footer() {
  return <footer className="bg-[#050505] border-t border-white/5" data-id="element-74" data-mp="32nukakr5twzs">
      {/* Brand Banner */}
      <div className="max-w-7xl mx-auto px-6 pt-16" data-id="element-75" data-mp="32m1bayt2r0om">
        <a href="#contact" className="block relative rounded-3xl overflow-hidden border border-white/10 group" aria-label="Get in touch with Clydeside Gas Safe Heating" data-id="element-76" data-mp="36qhg0wqyc229">
          <img src="https://cdn.magicpatterns.com/uploads/ddB6m9d5FqxG7S1TvHGUCT/ChatGPT_Image_Jun_4,_2026,_11_40_06_PM.png" alt="Clydeside Gas Safe Heating van — Local, Reliable, Professional" className="w-full h-auto object-cover transition-transform duration-700 group-hover:scale-[1.02]" data-id="element-77" data-mp="37fvf8oqf24t" />
        </a>
      </div>

      <div className="max-w-7xl mx-auto px-6 pt-16 pb-10" data-id="element-78" data-mp="2eyt6ehzk5tn4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-79" data-mp="2ew6z8jgkxg5f">
          {/* Brand */}
          <div className="space-y-6" data-id="element-80" data-mp="3lbdces4h47la">
            <Link to="/" className="flex items-center gap-3" data-id="element-81" data-mp="3gb8x35faxiwn">
              <div className="w-10 h-10 rounded-xl bg-gradient-primary p-[1px]" data-id="element-82" data-mp="3gctnciul2fop">
                <div className="w-full h-full bg-[#0a0a0a] rounded-xl flex items-center justify-center" data-id="element-83" data-mp="3v5n5kc18p9x2">
                  <Flame className="w-5 h-5 text-[#FF9500]" data-id="element-84" data-mp="3qapwj53yn0k6" />
                </div>
              </div>
              <div className="flex flex-col" data-id="element-85" data-mp="80nskgzggmbt">
                <span className="text-white font-bold text-lg leading-tight tracking-wide" data-id="element-86" data-mp="34p6j01lngek">
                  CLYDESIDE
                </span>
                <span className="text-xs text-gray-400 font-medium uppercase tracking-wider" data-id="element-87" data-mp="huwhkupa1x58">
                  Gas Safe Heating
                </span>
              </div>
            </Link>
            <p className="text-gray-400 text-sm leading-relaxed" data-id="element-88" data-mp="qtrq4dfsnjbp">
              Trusted, local Gas Safe registered engineers providing reliable
              heating solutions across Glasgow and Clydeside.
            </p>
            <div className="flex gap-4" data-id="element-89" data-mp="tta06hahyzxr">
              <a href="https://www.instagram.com/clydesidegassafeheating" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-gray-400 hover:text-white hover:bg-gradient-primary hover:text-black transition-all" data-id="element-90" data-mp="ytef42vrbmlv">
                <Instagram className="w-5 h-5" data-id="element-91" data-mp="1hjnvqhsajgx3" />
              </a>
            </div>
          </div>

          {/* Services */}
          <div data-id="element-92" data-mp="1mkjwimhcimya">
            <h4 className="text-white font-bold mb-6" data-id="element-93" data-mp="1mhpfz61gdma5">Our Services</h4>
            <ul className="space-y-3" data-id="element-94" data-mp="1rid15b3038wg">
              {services.slice(0, 6).map(s => <li key={s.slug} data-id="element-95" data-mp="3ocgi6ox89d6s">
                  <Link to={`/services/${s.slug}`} className="text-gray-400 hover:text-[#FFD600] transition-colors text-sm" data-id="element-96" data-mp="3od80wz5q7gfn">
                    {s.title}
                  </Link>
                </li>)}
            </ul>
          </div>

          {/* Quick Links */}
          <div data-id="element-97" data-mp="21ma9zisdbm10">
            <h4 className="text-white font-bold mb-6" data-id="element-98" data-mp="21nv2l2v4guw8">Quick Links</h4>
            <ul className="space-y-3" data-id="element-99" data-mp="1wnz0j95zjdjb">
              <li data-id="element-100" data-mp="1wp08v5vm9lxc">
                <Link to="/" className="text-gray-400 hover:text-[#FFD600] transition-colors text-sm" data-id="element-101" data-mp="1wpjrkot3cecf">
                  Home
                </Link>
              </li>
              <li data-id="element-102" data-mp="2pajmtv7lszg0">
                <Link to="/#about" className="text-gray-400 hover:text-[#FFD600] transition-colors text-sm" data-id="element-103" data-mp="2kcrzlehwm1i5">
                  About Us
                </Link>
              </li>
              <li data-id="element-104" data-mp="18yxmn6edva6n">
                <Link to="/#services" className="text-gray-400 hover:text-[#FFD600] transition-colors text-sm" data-id="element-105" data-mp="18zfqop7aesp4">
                  Services
                </Link>
              </li>
              <li data-id="element-106" data-mp="2wmfzmwislpfj">
                <Link to="/#contact" className="text-gray-400 hover:text-[#FFD600] transition-colors text-sm" data-id="element-107" data-mp="2wmzjwjvx0pwq">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-108" data-mp="3bk013tghd2gy">
            <h4 className="text-white font-bold mb-6" data-id="element-109" data-mp="3bjgtp6oghwh6">Contact Us</h4>
            <ul className="space-y-3" data-id="element-110" data-mp="3flbqbxvfzlom">
              <li className="text-gray-400 text-sm" data-id="element-111" data-mp="3fkah7yxzl99j">Glasgow, Scotland, UK</li>
              <li data-id="element-112" data-mp="31m2e19acxbpx">
                <a href="tel:07708233554" className="text-gray-400 hover:text-[#FFD600] transition-colors text-sm" data-id="element-113" data-mp="31khjhjo1lss2">
                  07708 233554
                </a>
              </li>
              <li data-id="element-114" data-mp="1q8gqtto25k71">
                <a href="mailto:Clydesidegasandheating@gmail.com" className="text-gray-400 hover:text-[#FFD600] transition-colors text-sm break-all" data-id="element-115" data-mp="1v5gw42d32ix3">
                  Clydesidegasandheating@gmail.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/5 pt-8 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-116" data-mp="1wlkyj8g6bkvx">
          <p className="text-gray-500 text-sm" data-id="element-117" data-mp="1ro2m382y6nj6">
            &copy; {new Date().getFullYear()} Clydeside Gas Safe Heating. All
            rights reserved.
          </p>
          <div className="bg-white/5 border border-white/10 px-4 py-2 rounded-full" data-id="element-118" data-mp="zx68u6cz6gvd">
            <span className="text-xs font-bold text-gray-400" data-id="element-119" data-mp="1dni58hglf1sb">
              GAS SAFE REGISTER NO.{' '}
              <span className="text-[#FFD600]" data-id="element-120" data-mp="18wjiaz13n5g3">972580</span>
            </span>
          </div>
        </div>
      </div>
    </footer>;
}